import { PayoutCommonOrderTraderOrderV1Status, PayoutCommonOrderV1Status } from '~/generated/payoutBackend/model';
import { type Order, type TraderOrder } from '../model';

type OrderId = string | { value?: string };
type SplitPart = Order['splitPart'] | TraderOrder['splitPart'];
type OrderLike = {
    childOrderIds?: OrderId[];
    parentOrderId?: OrderId;
    splitPart?: SplitPart;
};
type OrderWithStatus = {
    status?: Order['status'] | TraderOrder['status'];
};

export const getOrderIdValue = (id?: OrderId): string | undefined => {
    if (typeof id === 'string') {
        return id;
    }

    return id?.value;
};

export const getOrderSplitRelation = (order: OrderLike = {}) => {
    const parentOrderId = getOrderIdValue(order.parentOrderId);
    const childOrderIds = (order.childOrderIds ?? []).flatMap((id) => {
        const value = getOrderIdValue(id);

        return value ? [value] : [];
    });

    return {
        childOrderIds,
        isChild: Boolean(parentOrderId),
        isParent: childOrderIds.length > 0,
        parentOrderId,
    };
};

export const hasLiveInvestigationChild = (orders: OrderWithStatus[] = []): boolean => {
    return orders.some(
        ({ status }) =>
            status === PayoutCommonOrderV1Status.STATUS_INVESTIGATION ||
            status === PayoutCommonOrderTraderOrderV1Status.STATUS_INVESTIGATION,
    );
};

export const canOrderBeSentToInvestigation = (order: OrderLike & OrderWithStatus = {}): boolean => {
    const { isParent } = getOrderSplitRelation(order);
    const isAllowedStatus =
        order.status === PayoutCommonOrderV1Status.STATUS_IN_WORK ||
        order.status === PayoutCommonOrderV1Status.STATUS_APPROVED ||
        order.status === PayoutCommonOrderTraderOrderV1Status.STATUS_IN_WORK ||
        order.status === PayoutCommonOrderTraderOrderV1Status.STATUS_APPROVED;

    return isAllowedStatus && !isParent;
};
